var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"align-with-title":""}},[_c('v-tabs-slider',{attrs:{"color":"accent"}}),_c('v-tab',{attrs:{"to":{ name: 'Import Files (Beta)' }}},[_vm._v(" IMPORT FILES ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }